import { combineReducers } from "redux";
import view from "./view";

const quizReducer = combineReducers({
  view,
});

export default quizReducer;
